export enum ViewKind {
    Detail = 0,
    Card = 1,
    Compact = 2,
    Carousel = 3
}
